<style lang="css" scoped>

</style>

<template lang="html">
    <el-form :model="carExhibitionForm"
             :rules="rules"
             addAction="carShow/carShowInfo/insertCarShows.action"
             editAction="carShow/carShowInfo/updateCarShows.action"
             label-width="140px" selectAction="carShow/carShowInfo/selectCarShowsInfo.action" v-form>
        <el-form-item label="车展名称">
            <el-input placeholder="输入简要车展名称（比如：重庆年底购车节 全城开启）" v-model="carExhibitionForm.name"></el-input>
        </el-form-item>

        <el-form-item label="微信分享小标题">
            <el-input placeholder="请输入" v-model="carExhibitionForm.describes">
            </el-input>
        </el-form-item>

        <el-form-item label="发起渠道" prop="channelId" v-belong-to-admin>
            <channel-select :disabled="carExhibitionForm.channelId!=null&&carExhibitionForm.channelId!=''"
                            @change="onChannelChange"
                            placeholder="请选择发布渠道" ref="channel-select-by-car-show"
                            v-model="carExhibitionForm.channelId"></channel-select>
        </el-form-item>
        <el-form-item label="车展时间">
            <el-date-picker
                    @change="onDateTimeRangeChange"
                    end-placeholder="车展结束日期"
                    range-separator="至"
                    start-placeholder="车展开始日期"
                    type="datetimerange"
                    v-model="carExhibitionForm.rangeDate">
            </el-date-picker>
        </el-form-item>
        <el-form-item label="上传车展封面图：">
            <el-upload

                    :data="{floder:'carExhibition'}"
                    :http-request="onHttpRequest"
                    :show-file-list="false"
                    action="upload/uploadPic"
                    class="avatar-uploader"
                    v-model="carExhibitionForm.showImg">
                <img :src="carExhibitionForm.showImg.url"
                     class="avatar" v-if="carExhibitionForm.showImg&&carExhibitionForm.showImg.url">
                <i class="el-icon-plus avatar-uploader-icon" v-else></i>
            </el-upload>
            <div style="color:#999;">支持jpg格式，750*500px，上限1张</div>
        </el-form-item>

        <el-form-item label="上传车展介绍图：">
            <el-upload

                    :data="{floder:'carExhibition'}"
                    :http-request="onHttpRequest"
                    :show-file-list="false"
                    action="upload/uploadPic"
                    class="avatar-uploader"
                    v-model="carExhibitionForm.desImg">
                <img :src="carExhibitionForm.desImg.url"
                     class="avatar" v-if="carExhibitionForm.desImg&&carExhibitionForm.desImg.url">
                <i class="el-icon-plus avatar-uploader-icon" v-else></i>
            </el-upload>
            <div style="color:#999;">支持jpg格式，750*500px，上限1张</div>
        </el-form-item>

        <el-form-item label="表单大标题">
            <el-input placeholder="请输入" v-model="carExhibitionForm.formTitle">
            </el-input>
        </el-form-item>

        <el-form-item label="表单按钮文案">
            <el-input placeholder="请输入" v-model="carExhibitionForm.formButtonDes">
            </el-input>
        </el-form-item>

        <el-form-item>
            <el-button type="primary">保存</el-button>
        </el-form-item>
    </el-form>

</template>

<script>
import Config from '@/framework/configs/Config'
import BasicPager from '@/mixins/BasicPager'
import channelSelect from '@/components/channelSelect'

export default {
  extends: BasicPager,
  components: {
    channelSelect
  },
  data: function () {
    return {
      baseUrl: Config.baseUrl,
      carExhibitionForm: {
        id: null,
        rangeDate: [],
        carExhibitionName: '',
        desImg: null,
        formTitle: null,
        formButtonDes: null
      },
      rules: {
        name: [
          { required: true, message: '请输入车展名称', trigger: 'blur' }
        ],
        rangeDate: [
          { type: 'date', required: true, message: '请选择车展时间范围', trigger: 'change' }
        ],
        showImg: [
          { required: true, message: '请选择车展封面图', trigger: 'change' }
        ],
        formTitle: [
          { required: true, message: '表单大标题不能为空', trigger: 'change' }
        ],
        formButtonDes: [
          { required: true, message: '表单按钮不能为空', trigger: 'change' }
        ],
        describes: [
          { required: true, message: '请输入车展介绍', trigger: 'blur' }
        ],
        channelId: [
          { required: true, message: '请输入车展渠道', trigger: 'blur' }
        ]
      }
    }
  },
  created: function () {
    let params = this.$route.params
    this.carExhibitionForm.id = params.id

    let loginInfo = this.getLoginInfo()
    if (loginInfo.loginPath === 'channel') {
      this.carExhibitionForm.channelId = loginInfo.id
    }
  },
  methods: {

    // 渠道组件修改时间
    onChannelChange: function (channelId) {
      this.carExhibitionForm.channelId = channelId
    },
    onSelectInfo: function (dataInfo) {
      this.$nextTick(() => {
        this.$refs['channel-select-by-car-show'].settingDefaultChannelInfo({
          id: dataInfo.datas.channelId,
          channelName: dataInfo.datas.channelName
        })
      })
      let params = dataInfo.datas
      this.carExhibitionForm.rangeDate = [new Date(params.startTime), new Date(params.endTime)]
    },
    onDateTimeRangeChange: function (dateTimeRange) {
      if (!dateTimeRange) {
        this.carExhibitionForm.startTime = null
        this.carExhibitionForm.endTime = null
        return
      }

      if (dateTimeRange[0] && dateTimeRange[1]) {
        this.carExhibitionForm.startTime = dateTimeRange[0].getTime()
        this.carExhibitionForm.endTime = dateTimeRange[1].getTime()
      }

      this.$refs['table-template'].search()
    }
  }
}

</script>
